/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ICategoryTileData } from './category-tile.data';
import { ICategoryTileProps } from './category-tile.props.autogenerated';

export interface ICategoryTileViewProps extends ICategoryTileProps<ICategoryTileData> {}

/**
 *
 * CategoryTile component
 * @extends {React.PureComponent<ICategoryTileProps<ICategoryTileData>>}
 */
class CategoryTile extends React.PureComponent<ICategoryTileProps<ICategoryTileData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default CategoryTile;
